import { BadgeCheck, Building2, Sparkles, Cpu, Tag, MapPin } from "lucide-react";

const POINTS = [
  { icon: BadgeCheck, title: "Professional Installation", desc: "Every job finished to a standard we'd put our name on — because we do." },
  { icon: Building2, title: "Residential & Commercial Expertise", desc: "Homes, offices, and major data centers — one experienced team." },
  { icon: Sparkles, title: "Clean Workmanship", desc: "Concealed wiring, tidy racks, and no mess left behind." },
  { icon: Cpu, title: "Advanced Technology Experience", desc: "From fiber optics and OTDR testing to AI automation systems." },
  { icon: Tag, title: "Transparent Pricing", desc: "Published prices for standard work. Custom quotes before complex work begins." },
  { icon: MapPin, title: "Dallas–Fort Worth Coverage", desc: "Serving the entire DFW Metroplex and surrounding areas." },
];

export default function WhyChoose() {
  return (
    <section id="about" className="py-20 px-6 max-w-6xl mx-auto" data-testid="why-choose">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-mono uppercase tracking-widest text-[#d4af37]">One Company · Every System</span>
        <h2 className="font-display text-3xl sm:text-4xl uppercase tracking-tight text-white mt-2">Why Choose DuroTech28?</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {POINTS.map((p) => (
          <div key={p.title} className="rounded-xl bg-[#121216] border border-zinc-800 p-6 hover:border-[#d4af37]/40 transition-colors"
            data-testid={`why-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <p.icon className="w-6 h-6 text-[#d4af37] mb-4" strokeWidth={1.5} />
            <h3 className="text-sm font-semibold text-white mb-2">{p.title}</h3>
            <p className="text-xs text-zinc-500 leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
